export default __webpack_public_path__ + "static/media/ce-image.73562ce0.png";